import { ajax } from './createApi'
import { truckBaseUrl } from './urlConfig'

import axios from './createApi'

const { VUE_APP_ACTIVITY_API } = process.env

export function fetchUserInfo() {
    return ajax({
        method: 'GET',
        url: '',
        data: null
    })
}

/**
 *
 *
 * @export
 * @param {*} params 图片的数据
 * @returns
 */
export function createFeedBackImg(params) {
    return ajax({
        method: 'POST',
        url: `${truckBaseUrl}/suggestion/file/upload`,
        data: params
    })
}

export function createFeedBack(params) {
    console.log(params)
    return ajax({
        method: 'POST',
        url: `${truckBaseUrl}/suggestion/create`,
        data: params
    })
}

/**
 *
 * 请求错位的方法统计
 * @export
 * @param {*} params
 * @returns
 */
export function errorRequest(params) {
    return ajax({
        method: 'POST',
        url: `${truckBaseUrl}/error/request/save`,
        data: params
    })
}

/**
 *
 * 统计曝光量
 * @export
 * @param {*} params
 */
export function censusAnalyse(params) {
    return ajax({
        method: 'POST',
        url: `${truckBaseUrl}/event/analyse/trigger`,
        data: params
    })
}

export default {
    /**
     * 获取用户认证的草稿信息
     */
    getAuthInfoDraft: () => {
        return axios({
            url: 'identification/getAuthInfoDraft',
            method: 'get',
            params: null
        })
    },
    /**
     * 获取认证可选身份
     */
    getIdentityInfo: () => {
        return axios({
            url: 'identification/getIdentityInfo',
            method: 'get',
            params: null
        })
    },
    /**
     * 更新用户的身份信息
     * @param {*} identityId 选取的身份id
     */
    updateIdentityInfo: data => {
        return axios({
            method: 'post',
            url: 'identification/refreshIdentity',
            data
        })
    },
    /**
     * 获取键盘常用省份
     */
    getKeyBoardOftenProvince: () => {
        return axios({
            method: 'get',
            url: 'location/oftenProvince',
            params: null
        })
    },
    /**
     * @param file 需要上传的文件
     * 文件上传
     */
    createUploadFile: data => {
        return axios({
            method: 'post',
            url: 'fileUpload/upload',
            data
        })
    },
    /**
     * @param businessLicenseFileName 营业执照
     * @param vehicleLicenseFileName 行驶证
     * @param hasDriver 是否是驾驶员
     * @param name 姓名
     * @param phone 手机号
     * @param vco 车牌颜色
     * @param vehicleAuthType 认证类型 1 个人车辆 2 企业车辆
     * @param vno 车牌号
     * 新增车主认证
     */
    createVehicleAuth: data => {
        return axios({
            method: 'post',
            url: 'identification/vehicleAuth',
            data
        })
    },
    /**
     * @param fileName 驾驶证文件
     * @param name 司机认证姓名
     * 司机认证
     */
    createDriverAuth: data => {
        return axios({
            method: 'post',
            url: 'identification/driverAuth',
            data
        })
    },
    /**
     * @param contact 手机号码
     * @param fileNames 图片
     * @param suggestion 意见内容
     * 创建意见反馈
     */
    createFeedback: data => {
        return axios({
            method: 'post',
            url: 'suggestion/create',
            data
        })
    },
    /**
     *用户输入车架号认证
     * @param {*} data vin 车架号 vno 车牌号
     */
    checkVnoAuth: data => {
        return axios({
            method: 'POST',
            url: '/auth/checkVnoAuth',
            data
        })
    },
    /**
     * 用户上传驾驶证图片
     */
    identifyLicense: data => {
        return axios({
            method: 'POST',
            url: '/auth/scan/vehicle/license',
            data
        })
    },
    /**
     * 获取下载app的code
     * @param {*} params
     */
    getDownloadAuthCode: params => {
        return axios({
            method: 'POST',
            url: 'playTicket/sendAuthCode',
            data: params,
            baseURL: VUE_APP_ACTIVITY_API
        })
    },
    /**
     * 新用户下载app
    */
    createDownloadUser: params => {
        return axios({
            method: 'POST',
            url: 'playTicket/bindPhone',
            data: params,
            baseURL: VUE_APP_ACTIVITY_API
        })
    },
    /*
     * 查询用户剩余上传行驶证次数
     */
    getCountRemindTimes: vno => {
        return axios({
            method: 'get',
            url: `/auth/scan/countRemindTimes?vno=${vno}`
        })
    }
}
